/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {
  Diversion
}                                from '@/models/scenario/diversion';
import {DiversionChange}         from '@/screens/ide/diversion/diversion.change';
import {DiversionEditorComponent} from '@/components/diversion.editor.component';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class DeleteDiversionCommand
 *
 * @brief reversible deletion of a diversion
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DeleteDiversionCommand implements ICommand {

  private oldValue: DiversionChange         = null;
  private   editor: DiversionEditorComponent = null;
  private oldDiv: Diversion               = null;

    constructor(oldValue: DiversionChange, editor: DiversionEditorComponent) {

    this.oldValue = oldValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* find the block of the current selection */

    const    input: DiversionChange = this.oldValue.snapshot;

    this.oldDiv = Array.from(this.editor.scenario.diversions().values()).
      find(x => x._id === this.oldValue.id);

    Logger.debug('[diversion/table:del] deleting ', this.oldDiv);

    /* remove it from the scenario */

    this.editor.scenario.diversions().delete(this.oldDiv._id);

    /* refresh the views */

    this.editor.table.refreshTable();

    Logger.debug('[diversion/table:del] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[diversion/table:del] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /*
     * add the diversion back to the scenario, we can just re-insert, because scenario doesn't
     *  ever reuse diversion IDs
     *
     */

    Logger.debug('[diversion/table:del] adding back ', this.oldDiv);

    this.editor.scenario.diversions().set(this.oldDiv._id, this.oldDiv);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();

    Logger.debug('[diversion/table:del] refreshed.');

    /*
     * (re)select what was selected when we deleted, this brings back the
     * selection, and the the edit inputs as they were just before the
     * deletion.
     *
     */

    this.editor.table.doSelection(this.oldValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.oldValue instanceof DiversionChange) ? this.oldValue.id : '';

    return '[diversion/table:del] ' + b;
  }

}
